import { createAction, props } from '@ngrx/store'
import {
    AttachmentDto, ContractParcelDataDo,
    Drupoz,
    NonCadastralContractOwnerParamDto,
    NonCadastralContractParcelData,
    SubjectSignDateDto,
    Zpvypo,
} from '../../../../../api/backend'
import { ExtendedNonCadastralParcelContractEntity } from '../../model/ExtendedNonCadastralParcelContractEntity.model'
import { INonCadastralContractCreateContractState } from './non-cadastral-contract-create.reducer'
import { ContractTaskEnum } from '../../../../../shared/enums/contract-task.enum'

export const SOURCE = '[Non Cadastral Contract Create]'

export const resetState = createAction(
    `${ SOURCE } ResetState`,
)
export const setIsEdit = createAction(
    `${ SOURCE } SetIsEdit`, props<{ isEdit: boolean }>(),
)
export const setIsLoading = createAction(
    `${ SOURCE } SetIsLoading`, props<{ isLoading: boolean }>(),
)
export const setZpvypos = createAction(
    `${ SOURCE } SetZpvypos`, props<{ zpvypos: Zpvypo[] }>(),
)
export const setDrupozs = createAction(
    `${ SOURCE } SetDrupozs`, props<{ drupozs: Drupoz[] }>(),
)
export const prepareComputedContractNumber = createAction(
    `${ SOURCE } PrepareComputedContractNumber`, props<{ signatureYear: number }>(),
)
export const setRentDrupozCollection = createAction(
    `${ SOURCE } SetRentDrupozCollection`, props<{ contractRentDrupozCollection: any }>(),
)
export const setRentUnknownCollection = createAction(
    `${ SOURCE } SetRentUnknownCollection`, props<{ contractRentUnknownCollection: any }>(),
)
export const setIsEditingContract = createAction(
    `${ SOURCE } SetIsEditingContract`, props<{ isEditingContract: boolean }>(),
)
export const setIsEditingContractFalse = createAction(
    `${ SOURCE } SetIsEditingContractFalse`,
)
export const setRentCollectionsAndCompute = createAction(
    `${ SOURCE } SetRentCollectionsAndCompute`, props<{ contractRentDrupozCollection: any; contractRentUnknownCollection: any }>(),
)
export const computeContractPriceAndTax = createAction(
    `${ SOURCE } ComputeContractPriceAndTax`,
)
export const setEditedCpdOnDrupozChange = createAction(
    `${ SOURCE } SetEditedCpdOnDrupozChange`, props<{ drupozKodMan: any; useTaxReturnDrupozKodOriginal: boolean }>(),
)
export const onEditedCpdZpvypoChange = createAction(
    `${SOURCE} OnEditedCpdZpvypoChange`, props<{ katuzeKod: number; parcelId: number; drupozKodMan: number; drupozKod: number; zpvypoKodMan: number }>()
)
export const prepareSetEditedCpdProperty = createAction(
    `${SOURCE} PrepareSetEditedCpdProperty`, props<{ property: string; value: any }>()
)
export const prepareSetEditedCpdProperties = createAction(
    `${SOURCE} PrepareSetEditedCpdProperties`, props<{ properties: Array<{ key: string; value: any }> }>()
)
export const prepareContractOwnerParam = createAction(
    `${ SOURCE } PrepareContractOwnerParam`, props<{ ownerparams: NonCadastralContractOwnerParamDto[] }>(),
)
export const setEditedOwnerships = createAction(
    `${ SOURCE } SetEditedOwnerships`, props<{ editedOwnerships: any[] }>(),
)
export const prepareEditedCPD = createAction(
    `${ SOURCE } PrepareEditedCPD`, props<{ editedCPD: any }>(),
)
export const setEditedCPD = createAction(
    `${ SOURCE } SetEditedCPD`, props<{ editedCPD: any }>(),
)
export const setEditedParcel = createAction(
    `${ SOURCE } SetEditedParcel`, props<{ editedParcel: any }>(),
)
export const setEditedParcelKoeficientMan = createAction(
    `${SOURCE} SetEditedParcelKoeficientMan`, props<{ koeficientMan: number }>()
)
export const prepareContractCpds = createAction(
    `${ SOURCE } PrepareContractCpds`, props<{ cpds: NonCadastralContractParcelData[] }>(),
)
export const setContractCpds = createAction(
    `${ SOURCE } SetContractCpds`, props<{ cpds: any[] }>(),
)
export const noAction = createAction(
    `${ SOURCE } NoAction`,
)
export const prepareParcels = createAction(
    `${ SOURCE } PrepareParcels`, props<{ parcels: ExtendedNonCadastralParcelContractEntity[] }>(),
)
export const setParcels = createAction(
    `${ SOURCE } SetParcels`, props<{ parcels: ExtendedNonCadastralParcelContractEntity[] }>(),
)
export const setTotalAcreage = createAction(
    `${ SOURCE } SetTotalAcreage`, props<{ totalAcreage: number }>(),
)
export const setSameLVAndKatuze = createAction(
    `${ SOURCE } SetSameLVAndKatuze`, props<{ sameLVAndKatuze: boolean }>(),
)
export const prepareContract = createAction(
    `${ SOURCE } PrepareContract`, props<{ contract: INonCadastralContractCreateContractState }>(),
)
export const setContract = createAction(
    `${ SOURCE } SetContract`, props<{ contract: any }>(),
)
export const setContractParamTemplates = createAction(
    `${ SOURCE } SetContractParamTemplates`, props<{ contractParamTemplates: any[] }>(),
)
export const setSelectedContractTemplate = createAction(
    `${ SOURCE } SetSelectedContractTemplate`, props<{ selectedContractTemplate: any }>(),
)
export const setOwners = createAction(
    `${ SOURCE } SetOwners`, props<{ owners: any[] }>(),
)
export const setContractProperty = createAction(
    `${ SOURCE } SetContractProperty`, props<{ key: string; value: any }>(),
)
export const prepareOwners = createAction(
    `${ SOURCE } PrepareOwners`, props<{ owners: any[] }>(),
)
export const addParcels = createAction(
    `${ SOURCE } AddParcels`, props<{ parcelsToAdd: any[] }>(),
)
export const reorderParcels = createAction(
    `${ SOURCE } ReorderParcels`, props<{ parcelsOrder: any }>(),
)
export const orderParcels = createAction(
    `${ SOURCE } OrderParcels`, props<{ orderBy: string; parcelsOrder: any }>(),
)
export const setParcelsOrder = createAction(`${SOURCE} SetParcelsOrder`,
    props<{ parcelsOrder: {sortedBy: string; desc: boolean} }>()
)
export const removeAllParcels = createAction(
    `${ SOURCE } RemoveAllParcels`,
)
export const removeParcel = createAction(
    `${ SOURCE } RemoveParcel`, props<{ parcelId: number }>(),
)
export const setSelectedTab = createAction(
    `${ SOURCE } SetSelectedTab`, props<{ selectedTab: number }>(),
)
export const prepareTenants = createAction(
    `${ SOURCE } PrepareTenants`, props<{ tenants: any[] }>(),
)
export const setTenants = createAction(
    `${ SOURCE } SetTenants`, props<{ tenants: any[] }>(),
)
export const updateContractOwnersSignDate = createAction(
    `${ SOURCE } UpdateContractOwnersSignDate`, props<{ signDateList: SubjectSignDateDto[] }>(),
)
export const updateContractTenantsSignDate = createAction(
    `${ SOURCE } UpdateContractTenantsSignDate`, props<{ signDateList: SubjectSignDateDto[] }>(),
)
export const setAttachmentsLoading = createAction(
    `${ SOURCE } SetAttachmentsLoading`, props<{ attachmentsLoading: boolean }>(),
)
export const setAttachments = createAction(
    `${ SOURCE } SetAttachments`, props<{ attachments: AttachmentDto[] }>(),
)
export const addContractTenant = createAction(
    `${ SOURCE } AddContractTenant`, props<{ subject: any }>(),
)
export const setAttachmentOnlineDocumentLink = createAction(
    `${ SOURCE } SetAttachmentOnlineDocumentLink`, props<{ id: number; link: string }>(),
)
export const setIndividualProperty = createAction(
    `${ SOURCE } SetIndividualProperty`, props<{ key: string; value: any }>(),
)
export const computeContractExpirationDate = createAction(
    `${ SOURCE } ComputeContractExpirationDate`, props<{ contract: any }>(),
)
export const setContractAutoProlongationMonths = createAction(
    `${ SOURCE } SetContractAutoProlongationMonths`, props<{ autoProlongationMonths: number; repeatedly: boolean }>(),
)
export const setContractFirstNoticeAfterMonths = createAction(
    `${ SOURCE } SetContractFirstNoticeAfterMonths`, props<{ firstNoticeAfterMonths: number }>(),
)
export const setContractFirstNoticeAfterMonthsUnit = createAction(
    `${ SOURCE } SetContractFirstNoticeAfterMonthsUnit`, props<{ firstNoticeAfterMonthsUnit: string }>(),
)
export const prepareContractFirstPossibleTerminationDate = createAction(
    `${ SOURCE } PrepareContractFirstPossibleTerminationDate`, props<{ contract: any }>(),
)
export const setFirstPossibleTerminationDate = createAction(
    `${ SOURCE } SetFirstPossibleTerminationDate`, props<{ firstPossibleTerminationDate: string }>(),
)
export const prepareContractParamTemplates = createAction(
    `${ SOURCE } PrepareContractParamTemplates`, props<{ contractParamTemplates: any[] }>(),
)
export const setContractSelectedTemplate = createAction(
    `${ SOURCE } SetContractSelectedTemplate`, props<{ selectedContractTemplate: any }>(),
)
export const setIsRentTypeDefined = createAction(
    `${ SOURCE } SetIsRentTypeDefined`, props<{ isRentTypeDefined: boolean }>(),
)
export const setIsFormActive = createAction(
    `${SOURCE} SetIsFormActive`, props<{ isFormActive: boolean }>()
)
export const resetContract = createAction(
    `${ SOURCE } ResetContract`,
)
export const setContractDurationPeriod = createAction(
    `${ SOURCE } SetContractDurationPeriod`, props<{ durationPeriod: string }>(),
)
export const setContractDurationMonths = createAction(
    `${ SOURCE } SetContractDurationMonths`, props<{ durationMonths: number | string }>(),
)
export const setContractDurationMonthsUnit = createAction(
    `${ SOURCE } SetContractDurationMonthsUnit`, props<{ durationMonthsUnit: string }>(),
)
export const setContractDurationToDate = createAction(
    `${ SOURCE } SetContractDurationToDate`, props<{ durationToDate: string }>(),
)
export const setContractSignatureDate = createAction(
    `${ SOURCE } SetContractSignatureDate`, props<{ signatureDate: string }>(),
)
export const setContractParcelRent = createAction(
    `${ SOURCE } SetContractParcelRent`, props<{ parcelRentHybrid: any }>(),
)
export const updateEditedCpdConsequencies = createAction(
    `${ SOURCE } UpdateEditedCpdConsequencies`,
)
export const setEditedCpdParcelRent = createAction(
    `${ SOURCE } SetEditedCpdParcelRent`, props<{
        parcelRentAveragePrice: any;
        parcelRentFromAcreage: any;
        parcelRentParcelPrice: any;
        useParcelRent: boolean;
    }>(),
)
export const updateContractOwnerParamsPayoutDatesPayoutDateByKey = createAction(
    `${ SOURCE } UpdateContractOwnerParamsPayoutDatesPayoutDateByKey`, props<{ key: number; contractPayoutDate: any }>(),
)
export const updateContractOwnerParamsPayoutDatesPayoutDate = createAction(
    `${ SOURCE } UpdateContractOwnerParamsPayoutDatesPayoutDate`, props<{ contractPayoutDate: any }>(),
)
export const updateContractOwnerParamsPropertyByKey = createAction(
    `${ SOURCE } UpdateContractOwnerParamsTaxConcernedByKey`, props<{ key: number; property: string; value: any }>(),
)
export const updateContractOwnerParamsProperty = createAction(
    `${ SOURCE } UpdateContractOwnerParamsProperty`, props<{ property: string; value: any }>(),
)
export const updateContractOwnerParamsPropertyBySubjectId = createAction(
    `${ SOURCE } UpdateContractOwnerParamsPropertyBySubjectId`, props<{ subjectId: number; property: string; value: any }>(),
)
export const addContractOwnerParam = createAction(
    `${ SOURCE } AddContractOwnerParam`, props<{ contractOwnerParam: any }>(),
)
export const setContractPayoutToId = createAction(
    `${ SOURCE } SetContractPayoutToId`, props<{ payoutToId: number }>(),
)
export const updateContractCpdsUseParcelRent = createAction(
    `${ SOURCE } UpdateContractCpdsUseParcelRent`, props<{ useParcelRent: boolean }>(),
)
export const addContractOwner = createAction(
    `${ SOURCE } AddContractOwner`, props<{ subject: any }>(),
)
export const setContractTaxOwnerTo = createAction(
    `${ SOURCE } SetContractTaxOwnerTo`, props<{ ownerId: any }>(),
)
export const refreshOwner = createAction(
    `${ SOURCE } RefreshOwner`, props<{ subject: any }>(),
)
export const setRunningTask = createAction(
    `${SOURCE} SetRunningTask`, props<{ recomputePriceAndTaxNow: boolean; recomputePriceAndTaxPostponed: boolean }>()
)
export const setRunningTaskRecomputePriceAndTaxNow = createAction(
    `${SOURCE} SetRunningTaskRecomputePriceAndTaxNow`, props<{ recomputePriceAndTaxNow: boolean }>()
)
export const setRunningTaskRecomputePriceAndTaxPostponed = createAction(
    `${SOURCE} SetRunningTaskRecomputePriceAndTaxPostponed`, props<{ recomputePriceAndTaxPostponed: boolean }>()
)
export const setContractPriceAndTax = createAction(
    `${SOURCE} SetContractPriceAndTax`, props<{ priceContract: number; priceContractValorized: number; taxOwner: number; taxTenant: number }>()
)
export const handleComputePriceAndTax = createAction(
    `${SOURCE} HandleComputePriceAndTax`, props<{ isPostponed: boolean; task: ContractTaskEnum }>()
)
export const setEditedCpdWithConsequencies = createAction(
    `${SOURCE} SetEditedCpdWithConsequencies`, props<{ updatedEditedCpd: any; updatedCpds: any[]; updatedEditedParcel: any; updatedParcels: any[]; totalAcreage: number}>()
)

export const prepareSetEditedCpdDnepduosAcreage = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduosAcreage`, props<{ number: number; acreage: number }>()
)

export const prepareResetEditedCpdDnepduos = createAction( // Effect
    `${SOURCE} PrepareResetEditedCpdDnepduos`, props<{ number: number }>()
)

export const resetEditedCpdDnepduos = createAction(
    `${SOURCE} ResetEditedCpdDnepduos`, props<{ updatedEditedCpd: any; updatedCpds: ContractParcelDataDo[]; updatedEditedParcel: any; updatedParcels: any[]; totalAcreage: number  }>()
)

export const setEditedCpdTaxPayerIdAndTaxTenant = createAction(
    `${SOURCE} SetEditedCpdTaxPayerIdAndTaxTenant`, props<{ cpdTaxPayerId: any; cpdTaxTenant: any }>()
)

export const prepareSetEditedCpdDnepduosYear = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduosYear`, props<{ number: number; year: number }>()
)

export const prepareSetEditedCpdDnepduos = createAction(
    `${SOURCE} PrepareSetEditedCpdDnepduos`, props<{ number: number; dnepduos: any }>()
)